module.exports = __webpack_public_path__ + "static/media/add_todo_white.47123600.svg";